import { useCallback, useEffect, useState } from "react";
import { ICalendarProps } from "./Calendar.props";
import { formatWithoutTz } from "../helpers";
import { usePlanCreatorContext } from "../PlanCreatorContext";

export const useCalendarControl = (props: ICalendarProps) => {
  const {
    plan,
    selectedDays,
    isEdited,
    onSelectCurrentDay,
    selectDay,
    getPlanDayForDate,
  } = usePlanCreatorContext();

  const [today, setToday] = useState(new Date()); // какой-то костыль, чтобы не перепрыгивал месяц по клику на день

  useEffect(() => {
    if (props.currentValue) {
      setToday(props.currentValue);
    } else {
      setToday(new Date());
    }
  }, [props.currentValue]);

  const onSelectDate = (
    date: any | Date,
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    if (!props.readOnly) {
      selectDay(formatWithoutTz(date), e.ctrlKey || e.shiftKey);
    }
    onSelectCurrentDay(date, !props.readOnly);
  };

  const isSelected = useCallback(
    (date: Date): boolean => {
      if (selectedDays === undefined) return false;
      return (
        selectedDays.indexOf(date.getDay().toString()) > -1 ||
        selectedDays.indexOf(formatWithoutTz(date)) > -1
      );
    },
    [selectedDays]
  );

  return {
    selectedDays,
    today,
    isEdited,
    setToday,
    isSelected,
    onSelectDate,
    getPlanDayForDate,
  };
};
